const generateNewFlattenedKey = (
	currentFlattenedKey: string | null,
	key: string,
	type: 'object' | 'array' | string
) => {
	if (currentFlattenedKey === null) {
		if (!key.includes('.')) {
			return key
		}

		return `[${key}]`
	}

	if (type === 'object' && !key.includes('.')) {
		return `${currentFlattenedKey}.${key}`
	}

	return `${currentFlattenedKey}[${key}]`
}

const getInputValueType = (variable: unknown) => {
	if (Array.isArray(variable)) {
		return 'array'
	}

	if (
		typeof variable === 'object' &&
		variable !== null &&
		!(variable instanceof Date)
	) {
		return 'object'
	}

	return 'other'
}

const objectToFlatObjectInner = (
	inputValue: unknown,
	resultObject: Record<string, unknown>,
	flattenedKey: string | null = null
) => {
	const inputType = getInputValueType(inputValue)

	if (inputType === 'other') {
		return inputValue
	}

	for (const [key, value] of Object.entries(
		inputValue as Record<string, string>
	)) {
		const newKey = generateNewFlattenedKey(flattenedKey, key, inputType)

		const reqursiveResult = objectToFlatObjectInner(value, resultObject, newKey)

		if (
			(typeof reqursiveResult !== 'object' &&
				!Array.isArray(reqursiveResult)) ||
			reqursiveResult instanceof Date
		) {
			resultObject[newKey] = reqursiveResult
		}
	}

	return inputValue
}

export const objectToFlatObject = <T>(
	input: T
): Record<string, string> | null => {
	if (typeof input !== 'object' || Array.isArray(input) || input === null) {
		return null
	}

	const result = {}
	objectToFlatObjectInner(input, result)
	return result
}
